import type { BasketBadgeActionProps } from 'components/Forms/OrdersBasket/BasketBadge/BasketBadge';
import { connect } from 'react-redux';
import { getOrdersBasketTotalNumberOfForms } from 'state/orders-basket/selectors';
import type { AppState } from 'state/state.model';

interface OrdersBasketStateProps {
  numberOfItems: number;
}
interface OrderBasketOwnProps {
  isVisible: boolean;
}
export type OrdersBasketProps = OrdersBasketStateProps & BasketBadgeActionProps & OrderBasketOwnProps;

export const mapStateToProps = (state: AppState): OrdersBasketStateProps => ({
  numberOfItems: getOrdersBasketTotalNumberOfForms(state),
});
export const connectOrdersBasket = connect(mapStateToProps);
